import { fetchQuery, graphql } from "relay-runtime"
import { appointmentsTable_waitingRoomDay$data } from "@/modules/waiting-room/components/appointment-table/__generated__/appointmentsTable_waitingRoomDay.graphql"
import { WaitingRoomAppointmentsInput } from "@/modules/waiting-room/services/__generated__/WaitingRoomAppointmentsQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const waitingRoomQuery = graphql`
  query WaitingRoomAppointmentsQuery($filters: WaitingRoomAppointmentsInput) {
    waitingRoomAppointments(waitingRoomAppointmentsInput: $filters) {
      ...hasMoreDataWarning_waitingRoomAppointments
      waitingRoomDays {
        ...urgentAcuteAppointmentWarning_waitingRoomDay
        ...appointmentsTable_waitingRoomDay
      }
    }
  }
`

function fetchWaitingRoomData(filters?: WaitingRoomAppointmentsInput) {
  fetchQuery(
    RelayEnvironment,
    waitingRoomQuery,
    { filters },
    {
      fetchPolicy: "network-only",
    },
  ).subscribe({
    next: (data) => {
      // do not remove the next call as we need to observe the subscription to trigger the fetch
      // lets keep the console log as it helps troubleshooting live updates on Waiting room
      console.log("Waiting room data is", data)
    },
  })
}

type WaitingRoomAppointments = appointmentsTable_waitingRoomDay$data
type WaitingRoomDayGroup = appointmentsTable_waitingRoomDay$data[number]
type WaitingRoomSlotAppointment = appointmentsTable_waitingRoomDay$data[number]["slots"][number]["appointments"][number]

export {
  waitingRoomQuery,
  fetchWaitingRoomData,
  type WaitingRoomAppointments,
  type WaitingRoomDayGroup,
  type WaitingRoomSlotAppointment,
}
